exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hide[data-v-73e0d4a1]{display:none}.drag-area[data-v-73e0d4a1]:hover{background-color:#d8d8d8;cursor:pointer}", ""]);

// exports
